/**
 * Core entity types for the VMS platform.
 * All entities use string UUIDs as primary keys for offline-first compatibility.
 */
export const DEFAULT_REGISTRATION_FIELD_CONFIG = {
    company: { visible: true, required: false },
    email: { visible: true, required: true },
    phone: { visible: true, required: false },
};
export const GAMES = ["assetto-corsa", "rfactor-2"];
export const GAME_LABELS = {
    "assetto-corsa": "Assetto Corsa",
    "rfactor-2": "rFactor 2",
};
export const GAME_OPTIONS = GAMES.map(g => ({ value: g, label: GAME_LABELS[g] }));
export const GAME_CAPABILITIES = {
    "assetto-corsa": {
        supportsRestart: true,
        supportsAiToggle: false,
        supportsPit: true,
        supportsResetToTrack: true,
        requiresRaceTemplate: true,
        templateFormat: "ini",
        templateFormatLabel: "INI format",
        templateHelpText: "Paste INI sections (e.g. [ASSISTS]) that will be merged into race.ini before launch.",
        templatePlaceholder: "Paste AC assists INI content, e.g.:\n\n[ASSISTS]\nIDEAL_LINE=1\nAUTO_BLIP=1\nSTABILITY_CONTROL=1\nTRACTION_CONTROL=2\nABS=2\nAUTOMATIC_GEARS=1",
    },
    "rfactor-2": {
        supportsRestart: false,
        supportsAiToggle: true,
        supportsPit: true,
        supportsResetToTrack: true,
        requiresRaceTemplate: false,
        templateFormat: "json",
        templateFormatLabel: "JSON format",
        templateHelpText: "Paste JSON sections (e.g. DRIVER, Game Options) that will be merged into Player.JSON before launch.",
        templatePlaceholder: '{\n  "DRIVER": {\n    "Auto Shift#": 3,\n    "Stability Control#": 3,\n    "Traction Control#": 3\n  }\n}',
    },
};
export const INGAME_WIDGET_IDS = ["leaderboard", "nameplate"];
//# sourceMappingURL=entities.js.map